(() => {
  function initRotatingPlaceholders(root = document) {
    const inputs = root.querySelectorAll(
      'input[data-rotating-placeholder="true"]'
    );
    if (!inputs.length) return;

    inputs.forEach((input) => {
      // Prevent double-init
      if (input.dataset.rotatingInitialized === "true") return;
      input.dataset.rotatingInitialized = "true";

      const prefix = input.getAttribute("data-rotating-prefix") || "";
      const wordsRaw = input.getAttribute("data-rotating-words") || "";
      const words = wordsRaw
        .split(",")
        .map((w) => w.trim())
        .filter(Boolean);

      if (!words.length) return;

      let wordIndex = 0;
      let charIndex = 0;
      let deleting = false;

      const typeSpeed = 70;
      const deleteSpeed = 45;
      const holdMs = 900;

      const tick = () => {
        // If user is typing, don't fight them
        if (document.activeElement === input && input.value && input.value.length > 0) {
          setTimeout(tick, 600);
          return;
        }

        const word = words[wordIndex];

        if (!deleting) {
          charIndex++;
          input.placeholder = prefix + word.slice(0, charIndex);

          if (charIndex >= word.length) {
            deleting = true;
            setTimeout(tick, holdMs);
            return;
          }
          setTimeout(tick, typeSpeed);
          return;
        }

        // deleting
        charIndex--;
        input.placeholder = prefix + word.slice(0, Math.max(0, charIndex));

        if (charIndex <= 0) {
          deleting = false;
          wordIndex = (wordIndex + 1) % words.length;
          setTimeout(tick, 250);
          return;
        }

        setTimeout(tick, deleteSpeed);
      };

      tick();
    });
  }

  // Init on page load
  document.addEventListener("DOMContentLoaded", () => {
    initRotatingPlaceholders(document);
  });

  // If your drawer injects/re-renders HTML, this helps catch it
  const observer = new MutationObserver(() => initRotatingPlaceholders(document));
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
